/* ==========================================================================
   OOFOS Split Hero — entrance animation (fade-up), loaded once.
   Gated on data-osh-ready so content is visible without JS. Honors
   prefers-reduced-motion and the Shopify theme editor.
   ========================================================================== */
(function () {
  'use strict';

  if (window.__oofosSplitHeroInit) return;
  window.__oofosSplitHeroInit = true;

  var forEach = function (list, fn) { Array.prototype.forEach.call(list, fn); };
  var REDUCE = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function init(scope) {
    var root = scope && scope.querySelectorAll ? scope : document;
    var els = root.querySelectorAll('.oofos-split-hero--animate:not([data-osh-ready])');
    if (!els.length) return;

    if (REDUCE || !('IntersectionObserver' in window)) {
      forEach(els, function (el) { el.setAttribute('data-osh-ready', ''); el.classList.add('is-visible'); });
      return;
    }

    var io = new IntersectionObserver(function (entries, obs) {
      forEach(entries, function (entry) {
        if (entry.isIntersecting) { entry.target.classList.add('is-visible'); obs.unobserve(entry.target); }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -10% 0px' });

    forEach(els, function (el) { el.setAttribute('data-osh-ready', ''); io.observe(el); });
  }

  function boot() { init(document); }

  if (document.readyState !== 'loading') boot();
  else document.addEventListener('DOMContentLoaded', boot);

  document.addEventListener('shopify:section:load', function (e) { init(e.target || document); });
})();
